import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';

export function getChildrenEvents(user: AppUser, filter) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter: filter
    }
  };

  return axios.get(`${window.apiBase}/i/children/events`, config).then(response => {
    return response.data;
  });
}

export function getChildrenEvent(user: AppUser, eventId) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.get(`${window.apiBase}/i/children/events/${eventId}`, config).then(response => {
    return response.data;
  });
}

export function getChildrenEventsDates(user: AppUser, filter) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter: filter
    }
  };

  return axios.get(`${window.apiBase}/i/children/events/dates/distinct`, config).then(response => {
    return response.data;
  });
}

export function getParentCalendarData(
  user: AppUser,
  monthAndYearDate: Date,
  selectedDate: Date,
  childIdList: string[],
  filterType: string
) {
  const { roleSessionKey: key } = user;
  const monthStart = new Date(monthAndYearDate.getFullYear(), monthAndYearDate.getMonth(), 1);
  const monthEnd = new Date(monthAndYearDate.getFullYear(), monthAndYearDate.getMonth() + 1, 1);
  const dayStart = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
  const dayEnd = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate() + 1);

  return axios
    .get(`${window.apiBase}/i/children/events/calendar`, {
      headers: { usid: key },
      params: {
        monthStart: monthStart.toISOString(),
        monthEnd: monthEnd.toISOString(),
        dayStart: dayStart.toISOString(),
        dayEnd: dayEnd.toISOString(),
        childIds: childIdList.join(','),
        filterType
      }
    })
    .then(response => response.data);
}

export function sentChildrenAvailabilityReport(user: AppUser, eventId, data) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.post(`${window.apiBase}/i/children/events/${eventId}/messages/report`, data, config).then(response => {
    return response.data;
  });
}

export function getChildrenEventTasks(user: AppUser, eventId: string, activeSchoolId: string) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/events/${eventId}/tasks`, config).then(response => {
    return response.data;
  });
}

export function getSchoolEventMatchReportForParent(user: AppUser, schoolId: string, eventId: string) {
  const { roleSessionKey: key } = user;
  const config = {
    headers: { usid: key }
  };

  return axios.get(`${window.apiBase}/i/schools/${schoolId}/events/${eventId}/report`, config).then(response => {
    return response.data;
  });
}

export function getChildrenEventKits(user: AppUser, eventId: string) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.get(`${window.apiBase}/i/children/events/${eventId}/kits`, config).then(response => response.data);
}

export function getChildrenEventPhotos(user: AppUser, eventId: string) {
  const { roleSessionKey: key } = user;
  const config = {
    headers: { usid: key },
    params: { filter: { limit: 500, skip: 0 } }
  };
  return axios.get(`${window.apiBase}/i/children/events/${eventId}/photos`, config).then(response => response.data);
}

export function addChildrenEventPhoto(user: AppUser, eventId: string, data: { picUrl: string; accessPreset?: string }) {
  const { roleSessionKey: key } = user;
  const config = { headers: { usid: key } };
  return axios
    .post(`${window.apiBase}/i/children/events/${eventId}/photos`, data, config)
    .then(response => response.data);
}

export function deleteChildrenEventPhoto(user: AppUser, eventId: string, photoId: string) {
  const { roleSessionKey: key } = user;
  const config = { headers: { usid: key } };
  return axios
    .delete(`${window.apiBase}/i/children/events/${eventId}/photos/${photoId}`, config)
    .then(response => response.data);
}
